import { render, staticRenderFns } from "./AdvertisingInfo.vue?vue&type=template&id=00566a4c&scoped=true"
import script from "./AdvertisingInfo.vue?vue&type=script&lang=js"
export * from "./AdvertisingInfo.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingInfo.vue?vue&type=style&index=0&id=00566a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00566a4c",
  null
  
)

export default component.exports